import { render, staticRenderFns } from "./12.vue?vue&type=template&id=334b5f6f&"
import script from "./12.vue?vue&type=script&lang=js&"
export * from "./12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports